/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Are_You_Sure_Render_AllInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to render all Events?" |
*
* @param {Are_You_Sure_Render_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const are_you_sure_render_all = /** @type {((inputs?: Are_You_Sure_Render_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Are_You_Sure_Render_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Êtes-vous sûr de vouloir effectuer le rendu de tous les événements ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie wirklich alle Ereignisse rendern?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro di voler visualizzare tutti gli eventi?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите отобразить все события?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Estás seguro que deseas representar todos los eventos?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要渲染所有事件吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベントをレンダリングしてもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई सभी इवेंट्स को रेंडर करना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja renderizar todos os eventos?")
	return /** @type {LocalizedString} */ ("Are you sure you want to render all Events?")
});